// // import React from "react";
// // import Backdrop from "@mui/material/Backdrop";
// // import Box from "@mui/material/Box";
// // import Modal from "@mui/material/Modal";
// // import Fade from "@mui/material/Fade";

// // import cancel from "../../images/cancel.png";
// // import styles from "../../Styles/Playlist/view.module.css";

// // function ViewModal({ open, setOpen, id, name }) {
// //   const handleClose = () => setOpen(false);
// //   console.log("name", name);
// //   let newName = name.split("/youtu.be/", 2);
// //   console.log(newName[1], "chutiyapa");
// //   return (
// //     <div>
// //       <Modal
// //         aria-labelledby="transition-modal-title"
// //         aria-describedby="transition-modal-description"
// //         open={open}
// //         onClose={handleClose}
// //         closeAfterTransition
// //         BackdropComponent={Backdrop}
// //         BackdropProps={{
// //           timeout: 500,
// //         }}
// //       >
// //         <Fade in={open}>
// //           <Box className={styles.iframe}>
// //             <img
// //               src={cancel}
// //               alt="cancel"
// //               className={styles.cancel}
// //               onClick={handleClose}
// //             />
// //             <iframe
// //               width="80%"
// //               className={styles.frame}
// //               height="100%"
// //               src={`https://www.youtube.com/embed/${newName[1]}`}
// //               title="YouTube video player"
// //               // frameborder="0"
// //               allow="accelerometer; autoplay; clipboard-write; gyroscope;"
// //               allowfullscreen="true"
// //             ></iframe>

// //             <p className={styles.ttl}>Click anywhere to exit </p>
// //           </Box>
// //         </Fade>
// //       </Modal>
// //     </div>
// //   );
// // }

// // export default ViewModal;

// // =======================================================

// import React from "react";
// import Backdrop from "@mui/material/Backdrop";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";

// import cancel from "../../images/cancel.png";
// import styles from "../../Styles/Playlist/view.module.css";

// function ViewModal({ open, setOpen, videoId }) {
//   const handleClose = () => setOpen(false);

//   if (!videoId) return null; // 🛡️ guard

//   return (
//     <Modal open={open} onClose={handleClose} closeAfterTransition>
//       <Fade in={open}>
//         <Box className={styles.iframe}>
//           <img
//             src={cancel}
//             alt="cancel"
//             className={styles.cancel}
//             onClick={handleClose}
//           />

//           <iframe
//             width="80%"
//             height="100%"
//             className={styles.frame}
//             src={`https://www.youtube.com/embed/${videoId}`}
//             title="YouTube video player"
//             allow="accelerometer; autoplay; clipboard-write; gyroscope;"
//             allowFullScreen
//           />

//           <p className={styles.ttl}>Click anywhere to exit</p>
//         </Box>
//       </Fade>
//     </Modal>
//   );
// }

// export default ViewModal;

// =======================================================
import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { updateProgress } from "../../helper/progress.js";
import { isAuthenticated } from "../../helper/authApiCalls/auth.js";

import cancel from "../../images/cancel.png";
import styles from "../../Styles/Playlist/view.module.css";

function ViewModal({ open, setOpen, videoUrl, playlistId }) {
  console.log("in view modal, videoUrl:", videoUrl);
  const handleClose = () => setOpen(false);

  let videoId = "";
  if (videoUrl) {
    if (videoUrl.includes("youtu.be")) {
      videoId = videoUrl.split("youtu.be/")[1];
    } else if (videoUrl.includes("watch?v=")) {
      videoId = new URL(videoUrl).searchParams.get("v");
    } else {
      videoId = videoUrl;
    }
  }

  React.useEffect(() => {
    if (open && videoId && playlistId && isAuthenticated()) {
      const token = JSON.parse(localStorage.getItem("_access_token"));
      if (token) {
        updateProgress(playlistId, videoId, token);
      }
    }
  }, [open, videoId, playlistId]);

  if (!videoUrl || !videoId) return null;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box className={styles.iframe}>
          <img
            src={cancel}
            alt="cancel"
            className={styles.cancel}
            onClick={handleClose}
          />

          <iframe
            width="80%"
            height="100%"
            className={styles.frame}
            src={`https://www.youtube.com/embed/${videoId}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; gyroscope;"
            allowFullScreen
          />

          <p className={styles.ttl}>Click anywhere to exit</p>
        </Box>
      </Fade>
    </Modal>
  );
}

export default ViewModal;
